import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import cn from 'classnames';
import LinkWrapper from 'UI/components/LinkWrapper';
import styles from './styles.module.scss';

const Svg = dynamic(() => import('UI/components/Svg'));

const BookmarkContainer = ({
  title,
  buttonTitle,
  url,
  onClick,
  containerClass,
  titleClass,
  buttonClass,
}) => {
  const label = buttonTitle || 'Read more';
  const buttonClassName = cn(styles.button, buttonClass);

  return (
    <div className={cn(styles.bookmarkContainer, containerClass)}>
      <Svg
        type="bookMark"
        className={styles.bookmarkIcon}
      />
      <div className={styles.content}>
        <h3 className={cn(styles.title, titleClass)}>
          {title}
        </h3>
        {url ? (
          <LinkWrapper
            path={url}
            className={buttonClassName}
          >
            {label}
          </LinkWrapper>
        ) : (
          <button
            type="button"
            className={buttonClassName}
            onClick={onClick}
          >
            {label}
          </button>
        )}
      </div>
    </div>
  );
};

BookmarkContainer.propTypes = {
  title: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func,
  containerClass: PropTypes.string,
  titleClass: PropTypes.string,
  buttonClass: PropTypes.string,
};

export default BookmarkContainer;
